<template>
  <article class="thread-tree">
    <Status
      :key="statusId"
      :status-id="statusId"
      :replies="thread.getReplies(statusId)"
      :inline-expanded="thread.collapsable && thread.isExpanded"
      :expandable="!thread.isExpanded"
      :in-conversation="thread.isExpanded"
      :filter-place="thread.filterPlace"
      :focused="thread.focused === statusId"
      :in-profile="thread.inProfile"
      :profile-user-id="thread.profileUserId"
      class="conversation-status conversation-status-treeview status-fadein panel-body"

      :simple-tree="thread.simple"
      :thread-display-status="thread.threadDisplayStatus[statusId]"
      :can-dive="thread.canDive"

      @dive="thread.dive(statusId)"
      @goto="thread.goto(statusId)"
      @toggle-expanded="thread.toggleExpanded"
      @suspendable-state-change="thread.suspendableStateChange"
    />
    <div
      v-if="currentReplies.length > 0 && threadShowing"
      class="thread-tree-replies"
    >
      <ThreadTree
        v-for="replyStatusId in currentReplies"
        :key="replyStatusId"
        :depth="depth + 1"
        :status-id="replyStatusId"
      />
    </div>
    <div
      v-if="currentReplies.length && !threadShowing"
      class="thread-tree-replies thread-tree-replies-hidden"
    >
      <i18n-t
        v-if="thread.simple"
        scope="global"
        tag="button"
        keypath="status.thread_follow_with_icon"
        class="button-unstyled -link thread-tree-show-replies-button"
        @click.prevent="thread.dive(statusId)"
      >
        <template #icon>
          <FAIcon
            icon="angle-double-right"
          />
        </template>
        <template #text>
          <span>
            {{ $t('status.thread_follow', { numStatus: replyCount }, replyCount) }}
          </span>
        </template>
      </i18n-t>
      <i18n-t
        v-else
        scope="global"
        tag="button"
        keypath="status.thread_show_full_with_icon"
        class="button-unstyled -link thread-tree-show-replies-button"
        @click.prevent="thread.showThreadRecursively(statusId)"
      >
        <template #icon>
          <FAIcon
            icon="angle-double-down"
          />
        </template>
        <template #text>
          <span>
            {{ $t('status.thread_show_full', { numStatus: replyCount, depth: thread.totalReplyDepth[statusId] }, replyCount) }}
          </span>
        </template>
      </i18n-t>
    </div>
  </article>
</template>

<script src="./thread_tree.js"></script>

<style lang="scss">
.thread-tree-replies {
  margin-left: var(--status-margin);
  border-left: 2px solid var(--border);
}

.thread-tree-replies-hidden {
  padding: var(--status-margin);

  /* Make the button stretch along the whole row */
  display: flex;
  align-items: stretch;
  flex-direction: column;
}
</style>
